<form
  class="recovery-pass__form"
  [formGroup]="formGroup"
  (ngSubmit)="sendRecoveryPassEmailRequest()"
>
  <h1 class="recovery-pass__title">Recuperar Senha</h1>
  <p class="recovery-pass__sub-title">
    Informe o e-mail cadastrado para receber a senha
  </p>
  <hr class="w-25 mb-2" />
  <p>Insira o seu e-mail</p>

  <mat-form-field class="w-100">
    <mat-label>E-mail</mat-label>
    <input type="text" matInput formControlName="email" />
    <mat-error *ngIf="formGroup.get('email')?.hasError('required')">
      Este campo é obrigatório
    </mat-error>
    <mat-error *ngIf="formGroup.get('email')?.hasError('email')">
      Digite o e-mail corretamente
    </mat-error>
  </mat-form-field>

  <button
    class="w-100"
    mat-flat-button
    color="primary"
    type="submit"
    [disabled]="formGroup.invalid"
  >
    <span>Enviar e-mail</span>
  </button>

  <section class="recovery-pass__actions">
    <a routerLink="/entrar" class="default-hyper-link"
      >Lembrou a senha? Entrar</a
    >
  </section>
</form>
